import ContentStudio from "../../../../features/content-studio/ContentStudio";

export default function ContentManagment({ activeTab }) {
    if (activeTab !== "3") {
        return null;
    }
    return <ContentStudio />;
}
